var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question__wrapper"},[_c('div',{staticClass:"question__q"},[_vm._v("Q:")]),_c('div',{staticClass:"question__content",domProps:{"innerHTML":_vm._s(_vm.currentQuestion.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }